// Add this alongside your existing StatusBadge in components/ui/index.js

export const PartialBadge = () => (
  <span className="px-2 py-0.5 rounded-full text-xs bg-amber-900 text-amber-400 border border-amber-border">
    Partial
  </span>
);
